import { render, staticRenderFns } from "./Hiprint.vue?vue&type=template&id=565d8a30"
import script from "./Hiprint.vue?vue&type=script&lang=js"
export * from "./Hiprint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports